import { Trash2 } from "lucide-react";
import { BaseEdge, EdgeLabelRenderer, getBezierPath, type EdgeProps } from "@xyflow/react";

export function ThenEdge(props: EdgeProps) {
  const { sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, id, data, selected } = props;
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });
  const onDelete = data?.onDelete as (() => void) | undefined;
  const showDelete = Boolean(onDelete && selected);

  return (
    <>
      <BaseEdge id={id} path={edgePath} style={{ stroke: "#94a3b8", strokeWidth: 2 }} />
      {showDelete && (
        <EdgeLabelRenderer>
          <div
            className="absolute flex items-center bg-slate-100 p-1 rounded-full border border-slate-200 pointer-events-auto"
            style={{
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              zIndex: 2,
            }}
          >
            <button
              type="button"
              onClick={onDelete}
              className="p-0.5 rounded-full text-red-500 hover:text-red-600 hover:bg-red-50 transition-colors"
            >
              <Trash2 className="h-3 w-3" />
            </button>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
